import request from '@/utils/request';
import { parseCookies } from '@/lib/cookies';
import { config } from '@/config';

export const CURRENT_ACCOUNT_INFO = 'CURRENT_ACCOUNT_INFO';
export const PLANS = 'PLANS';
export const ADDONS = 'ADDONS';
export const PAYMENT_INFOS = 'PAYMENT_INFOS';
export const SAVE_CHOSEN_PLAN = 'SAVE_CHOSEN_PLAN';
export const CLEAR_CHOSEN_PLAN = 'CLEAR_CHOSEN_PLAN';
export const SAVE_CHOSEN_ADDONS = 'SAVE_CHOSEN_ADDONS';
export const CLEAR_CHOSEN_ADDONS = 'CLEAR_CHOSEN_ADDONS';

export const fetchCurrentAccount =
  ({ ctx = null } = {}) =>
  async dispatch => {
    const response = await request({
      path: `/v1/accounts/info`,
      token: ctx?.req && parseCookies(ctx)['token'],
      current_admin_token: ctx?.req && parseCookies(ctx)['current_admin_token'],
      impersonator_token: ctx?.req && parseCookies(ctx)['impersonator_token']
    });
    dispatch({
      payload: response,
      type: CURRENT_ACCOUNT_INFO
    });
  };

export const connectCard = body => async () =>
  await request({
    path: `/v1/accounts/connect_card`,
    method: 'POST',
    body
  });

export const fetchPlans =
  (query = {}) =>
  async dispatch => {
    const response = await request({
      path: `/v1/plans`,
      query
    });
    dispatch({
      payload: response,
      type: PLANS
    });

    return response;
  };

export const fetchAddons =
  (query = {}) =>
  async dispatch => {
    const response = await request({
      path: `/v1/addons`,
      query
    });
    dispatch({
      payload: response,
      type: ADDONS
    });
  };

export const updatePlan = body => async () =>
  await request({
    path: `/v1/accounts/update_plan`,
    method: 'POST',
    body
  });

export const purchaseAddons = body => async () =>
  await request({
    path: `/v1/addons/purchase`,
    method: 'POST',
    body
  });

export const changeRenewAddon =
  (addonId, body = {}) =>
  async () =>
    await request({
      path: `/v1/addons/${addonId}/change_renew`,
      method: 'PATCH',
      body
    });

export const fetchPaymentInfos =
  ({ limit, page, tab = undefined }) =>
  async (dispatch, getState) => {
    const currentUser = getState().currentUser;
    const query = { limit, page: page, tab };

    if (config(currentUser).EXTENDED_PLAN) query.all_statuses = true;

    const response = await request({
      path: `/v1/accounts/history`,
      query
    });
    dispatch({
      payload: response,
      type: PAYMENT_INFOS
    });
  };

export const cancelSubscription =
  (body = {}) =>
  async () =>
    await request({
      path: `/v1/accounts/cancel_subscription`,
      method: 'PUT',
      body
    });

export const retryPlan = () => async () =>
  await request({
    path: `/v1/accounts/retry_plan`,
    method: 'POST'
  });

export const saveChosenPlan = plan => dispatch => {
  dispatch({
    payload: plan,
    type: SAVE_CHOSEN_PLAN
  });
};

export const clearChosenPlan = () => dispatch => {
  dispatch({ type: CLEAR_CHOSEN_PLAN });
};

export const saveChosenAddons = addons => dispatch => {
  dispatch({
    payload: addons,
    type: SAVE_CHOSEN_ADDONS
  });
};

export const clearChosenAddons = () => dispatch => {
  dispatch({ type: CLEAR_CHOSEN_ADDONS });
};
